import { render, staticRenderFns } from "./DashboardMapsClientesRFC.vue?vue&type=template&id=513db784&scoped=true&"
import script from "./DashboardMapsClientesRFC.vue?vue&type=script&lang=js&"
export * from "./DashboardMapsClientesRFC.vue?vue&type=script&lang=js&"
import style0 from "./DashboardMapsClientesRFC.vue?vue&type=style&index=0&id=513db784&scoped=true&lang=css&"
import style1 from "./DashboardMapsClientesRFC.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513db784",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
